const Form = require('./Form');

/**
 * Same thing as Form.
 * The tools/asDictionary.js script requires an explicit function declaration for asDataDictionary to generate the output file.
 */
function asDataDictionary(hNode, context, parentAccessRestrictions) {
    return Form.asDataDictionary(hNode, context, parentAccessRestrictions);
}

module.exports = { asDataDictionary };
